import APIConnection from '@/API/APIConnection';
export default {
    check(code){
        return APIConnection.get(`accessCodes/${code}/check`);
    }
}